import { auth } from './auth/auth';
import { experiments } from './experiments/experiments';
import { offers } from './offers/offers';
import { payments } from './payments/payments';
import { polling } from './polling/polling';
import { trackingPage } from './trackingPage/trackingPage';

export const payex = {
  auth,
  trackingPage,
  payments,
  polling,
  offers,
  experiments,
};

export type PayexService = typeof payex;
